import React from "react";
import Modal from 'react-responsive-modal';
import database from '../firebase/firebase';
import {ShowNotification} from './HandleNotifications';
import {NotificationContainer} from 'react-notifications';
import {connect} from 'react-redux';
import { setProfile } from "../actions/_student_actions";

class ModalUserInfo extends React.Component{

    state = {
        name: '',
        lastName: '',
        email: '',
        locationName: '',
        cv: false,
        career: '',
        expertise: '',
        phoneNumber: '',
        experience: '',
        aboutMe: '',
        existCv: false
    }

    handleInputChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            [name] : value                
        });
    };

    componentWillMount(){
        this.setState({
            id: this.props.data.id,
            name: this.props.data.name,
            lastName: this.props.data.lastName,
            cv: this.props.data.cv,
            email: this.props.data.email,
            existCv: this.props.data.existCv,
            experience: this.props.data.experience,
            expertise: this.props.data.expertise,
            locationName: this.props.data.locationName,
            phoneNumber: this.props.data.phoneNumber,
            aboutMe: this.props.data.aboutMe,
            career: this.props.data.career
        })
    }

    updateInfo = () => {
        database.collection(`users`)
        .doc(this.props.data.id)
        .set(this.state, {merge: true})
        .then(() => {
            this.props.update(this.state)
            ShowNotification('success','Guardamos tus datos con exito!', 'Todo Listo')
        }).catch((e)=>{
            console.log(e)
        })
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.props.close} 
             closeOnOverlayClick={false} >
                <p className="up-title">¿Deseas actualizar tu información?</p>
                <div className="modal-container">
                    <div className="modal-couple-inputs">
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="name">Nombre</label>
                            <input className="modal-inputs" required="" type="text" name="name" 
                            onChange={this.handleInputChange} value={this.state.name}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="name">Apellidos</label>
                            <input className="modal-inputs" required="" type="text" name="lastName" 
                            onChange={this.handleInputChange} value={this.state.lastName}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="email">Correo Electronico</label>
                            <input className="modal-inputs" required="" type="text" name="email" 
                            onChange={this.handleInputChange} value={this.state.email}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="phoneNumber">Numero Telefonico</label>
                            <input className="modal-inputs" required="" type="text" name="phoneNumber" 
                            onChange={this.handleInputChange} value={this.state.phoneNumber}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="locationName">Ubicación</label>
                            <input className="modal-inputs" required="" type="text" name="locationName" 
                            onChange={this.handleInputChange} value={this.state.locationName}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="career">Carrera</label>
                            <input className="modal-inputs" required="" type="text" name="career" 
                            onChange={this.handleInputChange} value={this.state.career}/>
                        </div>
                        <div className="modal-mini-card">
                            <label className="labels-modal" htmlFor="expertise">Especialidad</label>
                            <input className="modal-inputs" required="" type="text" name="expertise" 
                            onChange={this.handleInputChange} value={this.state.expertise}/>
                        </div>
                    </div>
                    <label className="labels-modal" htmlFor="aboutMe">Acerca de ti...</label>
                    <textarea className="modal-textarea" rows="3" required="" value={this.state.aboutMe}
                    type="about" name="aboutMe" onChange={this.handleInputChange}></textarea>
                    <label className="labels-modal" htmlFor="experience">¿Cuentanos un poco de tu experiencia?</label>
                    <textarea className="modal-textarea" rows="3" required="" value={this.state.experience}
                    type="text" name="experience" onChange={this.handleInputChange}></textarea>
                    <button className="update-cv modal-button" 
                    onClick={() => { this.updateInfo() }} >Actualizar ahora</button>
                </div>
                <NotificationContainer />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.auth.uid,
    student: state.student
});

const mapDispatchToProps = (dispatch) => ({
    update: (newVals) => dispatch(setProfile(newVals))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalUserInfo);
